import { useState } from 'react';
import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import LayoutAuth from '../LayoutAuth';
import { PassRstStep, RstPassCollect, RstPassCollectDefaultProvider, RstPassValidateVcode } from './PasswordRecoverySmsValidateBody';
import { SupportedResources } from '@/dataProvider/tools';
import { useResourceRegister } from '@/utils/resourceRegister';
import LayoutPlain from '../LayoutPlain';


const resource: SupportedResources = 'resetpassword-confirm'
const resource2: SupportedResources = 'resetpassword-validate'

const PasswordRecoverySmsValidate: FC<{email: string, codeJwt: string, cid: string}> = ({
  email,
  codeJwt,
  cid,
}) => {
  useResourceRegister({ name: resource })
  useResourceRegister({ name: resource2 })
  
  const [states, setStates] = useState({
    prevData: { email, codeJwt, cid },
    stage: {
      newPass: '',
      confirmPass: '',
      smsVcode: '',
      smsVcodeId: -1,
    },
    errors: {} as any,
    touched: {} as any,
    vcodeSent: false,
    status: PassRstStep.Init,
  })

  return (
    states.status !== PassRstStep.CollectNewPass
      ? <LayoutAuth>
          <Helmet>
            <title>Password Recovery | OnData</title>
          </Helmet>
          <div role="main">
            <RstPassValidateVcode states={states} setStates={setStates} />
          </div>
        </LayoutAuth>
      : <LayoutPlain>
          <Helmet>
            <title>Password Recovery | OnData</title>
          </Helmet>
          <RstPassCollectDefaultProvider states={states}>
            <RstPassCollect states={states} setStates={setStates as any} />
          </RstPassCollectDefaultProvider>
        </LayoutPlain>
  );
};

export default PasswordRecoverySmsValidate;
